module.exports = __webpack_public_path__ + "img/gift.2dd8ce88.svg";